function normalizeErrorData(source) {
  if (!source) return null;
  if (source.error_key || source.errorKey) {
    return {
      error_key: source.error_key || source.errorKey,
      error_params: source.error_params || source.errorParams || {},
      error: source.error,
    };
  }
  if (source.response?.data) {
    return source.response.data;
  }
  return source;
}

export function translateApiError(data, t, formatMessage, fallback = '') {
  const payload = normalizeErrorData(data);
  if (!payload) return fallback;

  const key = payload.error_key;
  const params = payload.error_params || {};
  const catalog = t.apiErrors || {};

  if (key && catalog[key]) {
    return formatMessage(catalog[key], params);
  }

  if (key === 'validationError' && params.message) {
    return params.message;
  }

  return payload.error || fallback;
}

export function getApiErrorMessage(error, t, formatMessage, fallback = '') {
  return translateApiError(error?.response?.data ?? error, t, formatMessage, fallback);
}

export function resolveAuthError(result, t, formatMessage, fallback = '') {
  if (!result || result.success) return fallback;
  const keyFallback = result.fallbackKey && t.apiErrors?.[result.fallbackKey]
    ? formatMessage(t.apiErrors[result.fallbackKey])
    : fallback;
  return translateApiError(
    {
      error_key: result.errorKey,
      error_params: result.errorParams,
      error: result.error,
    },
    t,
    formatMessage,
    result.error || keyFallback,
  );
}
